export enum BadgeCategory{
    Result = 'Result',
    Goal = 'Goal',
    Assist = 'Assist',
    Sheet = 'Sheet',
    Card = 'Card',
}